import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;


const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const verifyToken = async () => {
      const token = localStorage.getItem('auth_token');
      if (!token) {
        setIsAuthenticated(false);
        return;
      }

      try {
        // Make a request to a protected endpoint to verify token
        await axios.get(`${API_URL}/dashboard`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setIsAuthenticated(true);
      } catch (error) {
        // If token is expired or invalid, backend will return 403
        if (error.response && (error.response.status === 403 || error.response.status === 401)) {
          localStorage.removeItem('auth_token');
          localStorage.removeItem('user_email');
          setIsAuthenticated(false);
        }
      }
    };

    verifyToken();

    // Set up periodic token verification
    const interval = setInterval(verifyToken, 60000); // Check every minute

    return () => clearInterval(interval);
  }, []);

  // Show loading while checking authentication
  if (isAuthenticated === null) {
    return <div>Loading...</div>;
  }

  return isAuthenticated ? children : <Navigate to="/login" />;

};

export default ProtectedRoute;
